<script>
    /**
     * This program is free software; you can redistribute it and/or
     * modify it under the terms of the GNU General Public License
     * as published by the Free Software Foundation; under version 2
     * of the License (non-upgradable).
     *
     * This program is distributed in the hope that it will be useful,
     * but WITHOUT ANY WARRANTY; without even the implied warranty of
     * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
     * GNU General Public License for more details.
     *
     * You should have received a copy of the GNU General Public License
     * along with this program; if not, write to the Free Software
     * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
     *
     * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
     */
    import { navigate, link } from 'svelte-navigator';
    import { Breadcrumb } from '@oat-sa-private/ui-components';
    import { IconBarButton } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';
    import { breadcrumbs, backLocation } from '../../stores/breadcrumbs.js';
</script>

<header class="navbar">
    {#if $backLocation}
        <IconBarButton
            size="base-16"
            icon="arrow-left-16"
            label={__('Go back to the homepage')}
            on:click={() => {
                navigate($backLocation);
            }}
        />
    {/if}
    <Breadcrumb items={$breadcrumbs} let:item>
        {#if item.href}
            <a href={item.href} use:link>
                {item.label}
            </a>
        {:else}
            {item.label}
        {/if}
    </Breadcrumb>
</header>

<style>
    .navbar {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: var(--space-half);
        background-color: var(--color-bg-default);
        width: 100%;
    }
</style>
